/**
 * @generated SignedSource<<9c8d5f25109790265d2065ee954f5524>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetMinimumBalanceInput = {
  amount: number;
};
export type AnalysisForecastMinimumBalanceMutation$variables = {
  input: SetMinimumBalanceInput;
};
export type AnalysisForecastMinimumBalanceMutation$data = {
  readonly setMinimumBalance: {
    readonly amount: number;
    readonly setAt: any;
    readonly setBy: string;
  };
};
export type AnalysisForecastMinimumBalanceMutation = {
  response: AnalysisForecastMinimumBalanceMutation$data;
  variables: AnalysisForecastMinimumBalanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MinimumBalance",
    "kind": "LinkedField",
    "name": "setMinimumBalance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastMinimumBalanceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisForecastMinimumBalanceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "007b1d84096598e043e4374fbbc5cf3c",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastMinimumBalanceMutation",
    "operationKind": "mutation",
    "text": "mutation AnalysisForecastMinimumBalanceMutation(\n  $input: SetMinimumBalanceInput!\n) {\n  setMinimumBalance(input: $input) {\n    amount\n    setBy\n    setAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "587848fc144b610420ef7bf852e04d50";

export default node;
